// Stamp-success chime, shared by the owner (StampConfirmOverlay) and staff
// (StaffStampOverlay) stamping flows, plus the mute toggle rendered on both
// scanner screens (QrScannerTab / StaffScanner). Preference persists per
// device via localStorage — default is ON.
//
// iOS WebKit gotcha: an <audio> element must be play()'d at least once from
// directly inside a synchronous user-gesture handler before it's allowed to
// play from an async context (our chime plays from stampMutation.onSuccess,
// which only runs after the stamp POST's fetch promise resolves — too late
// for WebKit's autoplay gate). unlockStampSound() below is called from
// SlideToConfirm's onPointerDown — the one gesture every stamp goes through
// — to prime the element early so the later async play() is allowed.

import chimeUrl from '../../assets/sound/chime.mp3'

const STORAGE_KEY = 'naya:stamp-sound-enabled'

let cachedAudio: HTMLAudioElement | null = null

function getAudio(): HTMLAudioElement {
  if (!cachedAudio) cachedAudio = new Audio(chimeUrl)
  return cachedAudio
}

export function isStampSoundEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off'
  } catch {
    return true
  }
}

export function setStampSoundEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'on' : 'off')
  } catch {
    // non-essential
  }
}

export function unlockStampSound(): void {
  try {
    const audio = getAudio()
    const playPromise = audio.play()
    void playPromise
      ?.then(() => {
        audio.pause()
        audio.currentTime = 0
      })
      .catch(() => {})
  } catch {
    // non-essential — worst case the later real play() stays gated
  }
}

export function playStampSuccessChime(): void {
  if (!isStampSoundEnabled()) return
  try {
    const audio = getAudio()
    audio.currentTime = 0
    void audio.play().catch(() => {})
  } catch {
    // sound is feedback only — never block the stamp flow on it
  }
}
